module.exports = __webpack_public_path__ + "static/media/photography.98a708fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/menu/photography.jpg
// module id = 157
// module chunks = 0